module.exports = __webpack_public_path__ + "static/media/scalability.dcecde9f.svg";